import { Typography } from "antd";
import styled from "styled-components";

const { Text } = Typography;

export const SizedText = styled(Text)<{ fontSize: string }>`
  font-size: ${({ fontSize }): string => fontSize};
`;
